import { useEffect, useState } from 'react';

const API = import.meta.env.VITE_API_URL;

export default function Referrals() {
  const [referrals, setReferrals] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/affiliate-portal/referrals`, { credentials: 'include' })
      .then((r) => r.json() as Promise<{ success: boolean; data: any[] }>)
      .then((j) => { if (j.success) setReferrals(j.data); setLoading(false); });
  }, []);

  if (loading) return <div className="text-center text-slate-500 dark:text-slate-400 py-8">Loading...</div>;

  const active = referrals.filter((r) => r.is_active);
  const ended = referrals.filter((r) => !r.is_active);

  return (
    <div>
      <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">My Referrals</h2>
      <p className="text-sm text-slate-600 dark:text-slate-300 mb-6">
        Locations you've referred to OAK. You earn a commission on each one's monthly plan payments while they remain active customers.
      </p>

      <Section title={`Active (${active.length})`} rows={active} />
      {ended.length > 0 && <div className="mt-6"><Section title={`Ended (${ended.length})`} rows={ended} /></div>}
    </div>
  );
}

function Section({ title, rows }: { title: string; rows: any[] }) {
  if (rows.length === 0) {
    return (
      <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-lg shadow-sm p-6">
        <h3 className="font-semibold mb-2">{title}</h3>
        <p className="text-sm text-slate-500 dark:text-slate-400">No referrals to show.</p>
      </div>
    );
  }
  return (
    <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-lg shadow-sm overflow-hidden">
      <div className="px-4 py-3 border-b font-medium">{title}</div>
      <table className="w-full text-sm">
        <thead className="bg-gray-50 dark:bg-slate-800">
          <tr>
            <th className="text-left p-3">Customer</th>
            <th className="text-left p-3">Referred Since</th>
            <th className="text-left p-3">Ended</th>
            <th className="text-left p-3">Source</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-b">
              <td className="p-3">{r.location_display}</td>
              <td className="p-3">{r.effective_start_date}</td>
              <td className="p-3 text-slate-500 dark:text-slate-400">{r.effective_end_date || <span className="text-green-600">— active —</span>}</td>
              <td className="p-3 text-xs text-slate-500 dark:text-slate-400">{r.created_by_method}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
